import Vue from 'vue'

export const EventBus = new Vue()

export const Event = {
  INITGAME: 'INITGAME',
  CAPTUREGAME: 'CAPTUREGAME',
  DEVICE: 'DEVICE',
  REFRESHLAYER: 'REFRESHLAYER',
  REFRESHCAROUSEL: 'REFRESHCAROUSEL',
  ADD_START: 'ADD_START',
  ADD_ENDING: 'ADD_ENDING',
  ADD_GAME_OBJECT: 'ADD_GAME_OBJECT',
  REMOVE_GAME_OBJECT: 'REMOVE_GAME_OBJECT',
  ADD_GAME_OBJECT_FOR_ALL: 'ADD_GAME_OBJECT_FOR_ALL',
  CLEAR_RESIZE_HIGHLIGHT: 'CLEAR_RESIZE_HIGHLIGHT',
  ERROR: 'ERROR',
  SAVESCENE: 'SAVESCENE',
  SILENT_SAVE: 'SILENT_SAVE',
  MOUSEUP: 'MOUSEUP',
  EDITOR_CHANGE: 'EDITOR_CHANGE',
  INIT_RIGHT_CONTEXT_MENU: 'INIT_RIGHT_CONTEXT_MENU',
  SCALE_SKETCHPAD: 'SCALE_SKETCHPAD',
  NODE_CHANGE: 'NODE_CHANGE',
  BG_REPLACE: 'BG_REPLACE',
  BG_REPLACE_CB: 'BG_REPLACE_CB', // 设置背景图回调
  DRAGON_BONE_UPDATE: 'DRAGON_BONE_UPDATE',
  ANIMATION_UPDATE: 'ANIMATION_UPDATE',
  LAYER_SCROLL_TO_NODE: 'LAYER_SCROLL_TO_NODE', // 图层模块滚动到节点
  REFRESH_STAGE: 'REFRESH_STAGE', // 刷新 konva 的虚拟舞台的所有节点
  ADD_GROUP: 'ADD_GROUP', // 添加组
  BEFORE_CHANGE_ORIENTATION: 'BEFORE_CHANGE_ORIENTATION', // 切换横竖屏前
  UN_GROUP: 'UN_GROUP', // 解除组
  GAME_READY: 'GAME_READY', // 游戏触发 ready
  GLOBALVAR_UPDATE: 'GLOBALVAR_UPDATE', // 全局变量更新
  EDIT_ACTION_HIDE: 'EDIT_ACTION_HIDE', // 收起响应动作编辑
  RESOURCE_POOL_REFRESH: 'RESOURCE_POOL_REFRESH', // 项目资产刷新
  CROPPER_CROP_MOVE: 'CROPPER_CROP_MOVE', // 裁剪框移动
  ADD_DRAW_LINE_AREA_NODE: 'ADD_DRAW_LINE_AREA_NODE', // 添加连线组件里的起止区域节点
  REMOVE_PAIR_CATEGORY: 'REMOVE_PAIR_CATEGORY', // 删除连线配对类别
  NODE_STYLE_UPDATE: 'NODE_STYLE_UPDATE', // 节点样式变化
  FREE_DRAW_LINE_STYLE_UPDATE: 'FREE_DRAW_LINE_STYLE_UPDATE', // 自由画线线条样式变化
  BOX2D_UPDATE: 'BOX2D_UPDATE', // box2d参数变化
  DRAG_BOUND_UPDATE: 'DRAG_BOUND_UPDATE', // 拖拽范围下拉选项修改更新
  ERASE_HAND_IMAGE_SELECT_UPDATE: 'ERASE_HAND_IMAGE_SELECT_UPDATE', // 更新擦除组件的跟手图片激活
  DRAG_RESET_POS: 'DRAG_RESET_POS', // 拖拽松手后复位
  DRAG_DIRECTION: 'DRAG_DIRECTION', // 拖拽方向
  MASK_SHAPE_UPDATE: 'MASK_SHAPE_UPDATE', // 更新遮罩效果
  IV_BRAIN_CHANGE: 'IV_BRAIN_CHANGE',
  IV_BRAIN_INIT: 'IV_BRAIN_INIT',
  IV_GUIDE_STEP: 'IV_GUIDE_STEP',
  IV_GUIDE_STEP_REMOVE: 'IV_GUIDE_STEP_REMOVE',
}
